import { Body, Controller, Post } from '@nestjs/common';
import { ContainerService } from './container.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ContainerDTO } from './dto/container.dto';
import { AllBlStatusInfo, AllContainerStatusInfo, BillNoUpdateRequest, BookingContainerResponse, ConfirmOrAssignSoResponse, ContainerDetailsResponse, ContainerDispatchedToPlantResponse, ContainerResponse, EtdUpdateRequest, FillSealInfoResponse,ContaierRegisterRequest, AllLoadingReportResponse, ShipmentDetailsDto, ShippmentDetailsResponse, ContainerReportResponse, ContainerBarChartResponseModel, Containertrnd, ContainerStatusRequest } from '@gtpl/shared-models/logistics';

import { ApiTags } from '@nestjs/swagger';
import { BookContainerDto } from './dto/book-container.dto';
import { DispatchedToPlant } from './dto/container-dispatched-to-plant.dto';
import { ContainerStatusInfo } from './dto/containers-status-info';
import { DraftReceived } from './dto/draft-received.dto';
import { PlantInvoiceDetailsRequest } from '@gtpl/shared-models/sale-management';
import { ContainerSoIdRequest } from './dto/container-soId.request';
import { ContainerIdRequest } from './dto/container-id.request';
import { UnitRequest } from './dto/unit.id.request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { ContainerYearRequest } from './dto/container-year-request';
@ApiTags('container')
@Controller('container')
export class ContainerController {
    constructor(private service: ContainerService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    // containerServices: any;

    // @Post('/CreateContainer')
    // async CreateContainer(@Body() containerData: ContainerDTO):Promise<ContainerResponseModel>{
    //     try{
    //         return this.containerServices.CreateContainer(containerData, false);
    //     }catch(error){
    //         return error;
    //     }
    // }


    // get All Container Status Info
    @Post('getAllContainerStatusInfo')
    async getAllContainerStatusInfo(@Body() req: UnitRequest): Promise<AllContainerStatusInfo> {
        // console.log(containerRegisterRequest);
        try {
            return this.service.getAllContainerStatus(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllContainerStatusInfo, error);
        }
    }

    // To bookContainer
    @Post('bookContainer')
    async bookContainer(@Body() containerInfo: BookContainerDto): Promise<BookingContainerResponse> {
        try {
            return this.service.bookContainer(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(BookingContainerResponse, error);
        }
    }

    // To containerDispatchedToPlant
    @Post('containerDispatchedToPlant')
    async containerDispatchedToPlant(@Body() containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.containerDispatchedToPlant(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To confirmOrAssignSo
    @Post('confirmOrAssignSo')
    async confirmOrAssignSo(@Body() containerInfo: DispatchedToPlant): Promise<ConfirmOrAssignSoResponse> {
        try {
            return this.service.confirmOrAssignSo(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ConfirmOrAssignSoResponse, error);
        }
    }

    // To fill seal info
    @Post('fillSealInfo')
    async fillSealInfo(@Body() containerInfo: ContainerDTO): Promise<FillSealInfoResponse> {
        try {
            return this.service.fillSealInfo(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(FillSealInfoResponse, error);
        }
    }

    // To Update the status to ReadyToBook
    @Post('updateToReadyToBook')
    async updateToReadyToBook(@Body() containerInfo: DispatchedToPlant): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToReadyToBook(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to Booked
    @Post('updateToBooked')
    async updateToBooked(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToBooked(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateStatusToLoading')
    async updateStatusToLoading(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateStatusToLoading(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to DispatchedToPlant
    @Post('updateToDispatchedToPlant')
    async updateToDispatchedToPlant(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToDispatchedToPlant(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to Loading
    @Post('updateToLoading')
    async updateToLoading(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToLoading(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Update the status to LoadedAndSealed
    @Post('updateToLoadedAndSealed')
    async updateToLoadedAndSealed(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerDispatchedToPlantResponse> {
        try {
            return this.service.updateToLoadedAndSealed(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To initiate dispatch
    @Post('initiateDispatch')
    async initiateDispatch(@Body() containerInfo: ContainerStatusInfo) {
        try {
            return this.service.initiateDispatch(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    // To Ship the container
    @Post('shipContainer')
    async shipContainer(@Body() containerInfo: ContainerStatusInfo): Promise<ContainerResponse> {
        try {
            return this.service.shipContainer(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerResponse, error);
        }
    }


    // ---------------- BL status services ------------------

    @Post('getAllContainerBlStatusInfo')
    async getAllContainerBlStatusInfo(): Promise<AllBlStatusInfo> {
        try {
            return this.service.getAllContainerBlStatusInfo();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllBlStatusInfo, error);
        }
    }

    @Post('notReceived')
    async notReceived(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.notReceived(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    @Post('draftReceived')
    async draftReceived(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.draftReceived(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    @Post('oblReceived')
    async oblReceived(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.oblReceived(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }

    @Post('receivedAndShared')
    async receivedAndShared(@Body() containerInfo: DraftReceived) {
        try {
            return this.service.receivedAndShared(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateEtd')
    async updateEtd(@Body() containerInfo: EtdUpdateRequest) {
        console.log(containerInfo);
        try {
            return this.service.updateEtd(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateBlNo')
    async updateBlNo(@Body() containerInfo: BillNoUpdateRequest) {
        console.log(containerInfo);
        try {
            return this.service.updateBlNo(containerInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDispatchedToPlantResponse, error);
        }
    }
    @Post('updateShipmentDetails')
    async updateShipmentDetails(@Body() req: ShipmentDetailsDto): Promise<ContainerDetailsResponse> {
        try {
            return this.service.updateShipmentDetails(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDetailsResponse, error);
        }
    }
    @Post('getShipmentDetails')
    async getShipmentDetails(@Body() req: ContainerIdRequest): Promise<ShippmentDetailsResponse> {
        try {
            return this.service.getShipmentDetails(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ShippmentDetailsResponse, error);
        }
    }


    /**
     * To get containerNumber,lineSeal,Eseal
     * @Param saleOrderId
     */
    @Post('/getContainerDeatils')
    async getContainerDeatils(@Body() soId: ContainerSoIdRequest): Promise<ContainerDetailsResponse> {
        try {
            return await this.service.getContainerDeatils(soId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(ContainerDetailsResponse, error);
        }
    }

    @Post('/getLoadingReportDetails')
    async getLoadingReportDetails(): Promise<AllLoadingReportResponse> {
        try {
            return await this.service.getLoadingReportDetails();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllLoadingReportResponse, error);
        }
    }
    
    @Post('/getContainerReportData')
    async getContainerReportData(): Promise<ContainerReportResponse> {
        try{
            return await this.service.getContainerReportData();
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContainerReportResponse, error);
        }
    }
    @Post('/getMonthWiseContainersData')
    async getMonthWiseContainersData(@Body()req:ContainerYearRequest): Promise<ContainerBarChartResponseModel> {
        try{
            return await this.service.getMonthWiseContainersData(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(ContainerBarChartResponseModel, error);
        }
    }

    @Post('/getTopFiveDestinations')
    async getTopFiveDestinations(): Promise<CommonResponse>{
        try{
            return await this.service.getTopFiveDestinations();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
    @Post('/getLogisticsLifeCycleData')
    async getLogisticsLifeCycleData(): Promise<CommonResponse>{
        try{
            return await this.service.getLogisticsLifeCycleData();
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }
@Post('/gettotalsaleorderShipped')
async gettotalsaleorderShipped(@Body()req:ContainerYearRequest):Promise<CommonResponse>{
    try{
        return await this.service.gettotalsaleorderShipped(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}
@Post('/totalsaleordersshiipedinyear')
async totalsaleordersshiipedinyear(@Body()req:ContainerYearRequest):Promise<CommonResponse>{
    try{
        return await this.service.totalsaleordersshiipedinyear(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}
@Post('/totalsaleordersShippedinDayWise')
async totalsaleordersShippedinDayWise(@Body()req:ContainerYearRequest):Promise<CommonResponse>{
    try{
        return await this.service.totalsaleordersShippedinDayWise(req);
    }catch(error){
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}

@Post('/getLogisticsDailyUsage')
async getLogisticsDailyUsage():Promise<CommonResponse>{
    try{
        return await this.service.getLogisticsDailyUsage();
    }catch(error){
        console.log(error)
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}

@Post('/getSoIdsByStatus')
async getSoIdsByStatus(soId:ContainerStatusRequest): Promise<CommonResponse>{
    try{
        return await this.service.getSoIdsByStatus(soId);
    }catch(error){
        console.log(error)
        return this.applicationExceptionHandler.returnException(CommonResponse,error);
    }
}
}
